import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import './_styles_/MainContent.css';
import { hasPrivilege } from '../hocs/withPrivileges';
import useAuthentication from '../hooks/useAuthentication';
import Footer from './Footer';
import Auctions from './auctions/Auctions';
import Submarkets from './submarkets/Submarkets';
import Privileges from '../utils/Privileges';
import Currencies from './currencies/Currencies';
import Messages from './messages/Messages';
import PrivilegedRoute from './PrivilegedRoute';
import Users from './users/Users';
import Products from './products/Products';
import Members from './members/Members';
import ClearingHouses from './clearing-houses/ClearingHouses';
import Zones from './zones/Zones';
import AuctioneerDataTemplates from './auctioneer-data-templates/AuctioneerDataTemplates';
import ManualCashLimits from './manual-cash-limits/ManualCashLimits';
import CashLimits from './cash-limits/CashLimits';
import AuctionLimits from './auction-limits/AuctionLimits';
import AuctionTemplates from './auction-templates/AuctionTemplates';
import Emails from './emails/Emails';
import Settings from './settings/Settings';
import Holidays from './holidays/Holidays';
import CashLimitUploadEvents from './cash-limit-upload-events/CashLimitUploadEvents';

function MainContent() {
    const { userPrivileges } = useAuthentication();
    const auctionsPrivileges = [Privileges.AUCTION_VIEW_ALL, Privileges.AUCTION_VIEW_OWN, Privileges.AUCTION_EDIT];
    return (
        <div className="main-content">
            <Switch>
                {
                    hasPrivilege(userPrivileges, auctionsPrivileges)
                        ? <Redirect from="/" to="/auctions" exact />
                        : <Redirect from="/" to="/users" exact />
                }
                <PrivilegedRoute
                    path="/settings"
                    sufficientPrivileges={[Privileges.SETTINGS_EDIT]}
                    render={() => (
                        <Settings />
                    )}
                />
                <PrivilegedRoute
                    path="/messages"
                    sufficientPrivileges={[Privileges.MESSAGE_VIEW, Privileges.MESSAGE_EDIT]}
                    render={() => (
                        <Messages />
                    )}
                />
                <PrivilegedRoute
                    path="/email-templates"
                    sufficientPrivileges={[Privileges.EMAIL_TEMPLATE_EDIT, Privileges.EMAIL_TEMPLATE_VIEW]}
                    render={() => (
                        <Emails />
                    )}
                />
                <PrivilegedRoute
                    path="/auctions"
                    sufficientPrivileges={auctionsPrivileges}
                    render={() => (
                        <Auctions />
                    )}
                />
                <PrivilegedRoute
                    path="/products"
                    sufficientPrivileges={[Privileges.PRODUCT_EDIT, Privileges.PRODUCT_VIEW]}
                    render={() => (
                        <Products />
                    )}
                />
                <PrivilegedRoute
                    path="/auction-limits"
                    sufficientPrivileges={[Privileges.AUCTION_LIMIT_EDIT, Privileges.AUCTION_LIMIT_VIEW]}
                    render={() => (
                        <AuctionLimits />
                    )}
                />
                <PrivilegedRoute
                    path="/auction-templates"
                    sufficientPrivileges={[Privileges.AUCTION_TEMPLATE_EDIT, Privileges.AUCTION_TEMPLATE_VIEW]}
                    render={() => (
                        <AuctionTemplates />
                    )}
                />
                <PrivilegedRoute
                    path="/auctioneer-data-templates"
                    sufficientPrivileges={[Privileges.AUCTIONEER_DATA_TEMPLATE_EDIT]}
                    render={() => (
                        <AuctioneerDataTemplates />
                    )}
                />
                <PrivilegedRoute
                    path="/cash-limit-upload-events"
                    sufficientPrivileges={[Privileges.CASH_LIMIT_EDIT, Privileges.CASH_LIMIT_VIEW]}
                    render={() => (
                        <CashLimitUploadEvents />
                    )}
                />
                <PrivilegedRoute
                    path="/cash-limits"
                    sufficientPrivileges={[Privileges.CASH_LIMIT_EDIT, Privileges.CASH_LIMIT_VIEW]}
                    render={() => (
                        <CashLimits />
                    )}
                />
                <PrivilegedRoute
                    path="/clearing-houses"
                    sufficientPrivileges={[Privileges.CLEARING_HOUSE_EDIT, Privileges.CLEARING_HOUSE_VIEW]}
                    render={() => (
                        <ClearingHouses />
                    )}
                />
                <PrivilegedRoute
                    path="/submarkets"
                    sufficientPrivileges={[Privileges.SUBMARKET_EDIT]}
                    render={() => (
                        <Submarkets />
                    )}
                />
                <PrivilegedRoute
                    path="/currencies"
                    sufficientPrivileges={[Privileges.CURRENCY_EDIT]}
                    render={() => (
                        <Currencies />
                    )}
                />
                <PrivilegedRoute
                    path="/holidays"
                    sufficientPrivileges={[Privileges.HOLIDAY_EDIT]}
                    render={() => (
                        <Holidays />
                    )}
                />
                <PrivilegedRoute
                    path="/users"
                    sufficientPrivileges={[Privileges.USER_EDIT, Privileges.USER_VIEW]}
                    render={() => (
                        <Users />
                    )}
                />
                <PrivilegedRoute
                    path="/manual-cash-limits"
                    sufficientPrivileges={[Privileges.MANUAL_CASH_LIMIT_EDIT, Privileges.MANUAL_CASH_LIMIT_VIEW]}
                    render={() => (
                        <ManualCashLimits />
                    )}
                />
                <PrivilegedRoute
                    path="/members"
                    sufficientPrivileges={[Privileges.MEMBER_EDIT, Privileges.MEMBER_VIEW]}
                    render={() => (
                        <Members />
                    )}
                />
                <PrivilegedRoute
                    path="/zones"
                    sufficientPrivileges={[Privileges.ZONE_EDIT_ALL, Privileges.ZONE_VIEW_ALL, Privileges.ZONE_VIEW_OWN]}
                    render={() => (
                        <Zones />
                    )}
                />
            </Switch>
            <Footer />
        </div>
    );
}

export default MainContent;
